import React from 'react';
import {Collapse} from 'antd';

interface FaqItem {
	key: string;
	question: string;
	answer: string;
}

interface FaqSectionProps {
	title?: string;
	faqs: FaqItem[];
}

const defaultFaqs: FaqItem[] = [
	{
		key: '1',
		question: 'How does Permworks differ from traditional recruiting agencies?',
		answer: 'Permworks offers direct hiring with no middlemen, no salary markup, and no lock-in contracts. We use AI-powered matching and automated screening to connect you with top Filipino talent efficiently and cost-effectively.',
	},
	{
		key: '2',
		question: 'Is there a fee to post a job?',
		answer: 'No, posting a job on Permworks is completely free. You only pay when you decide to hire a candidate.',
	},
	{
		key: '3',
		question: 'How quickly can I expect to receive applications?',
		answer: 'Most job postings receive their first applications within 24-48 hours. The exact timing depends on the role specifics and market demand.',
	},
];

const FaqSection: React.FC<FaqSectionProps> = ({title = 'Frequently Asked Questions', faqs = defaultFaqs}) => {
	const items = faqs.map((faq) => ({
		key: faq.key,
		label: <span className="text-dm font-medium text-darkCharcoal">{faq.question}</span>,
		children: <p className="text-sm font-light text-charcoal">{faq.answer}</p>,
	}));

	return (
		<div className="flex flex-col items-center px-4 py-12 sm:py-20">
			<h2 className="text-2xl font-normal text-darkCharcoal mb-8">{title}</h2>
			<Collapse
				items={items}
				expandIconPosition="end"
				className="w-full max-w-4xl"
				style={{
					background: 'transparent',
				}}
			/>
		</div>
	);
};

export default FaqSection;
